export class CustomEventsDirective {
    constructor() {
        this.restrict = 'AE';
    }
    get scope() {
        return {
            customEvents: '<',
        };
    }
    compile() {
        return this.link.bind(this);
    }
    link(scope, element) {
        try {
            scope.$watch('customEvents', () => {
                const { customEvents } = scope;
                const el = element[0];
                if (customEvents) {
                    customEvents.forEach((customEvent) => {
                        el.addEventListener(customEvent.event, (ev) => {
                            if (ev.detail && customEvent.name) {
                                ev.detail.name = customEvent.name;
                            }
                            customEvent.cb(ev);
                        });
                    });
                }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static factory() {
        return new CustomEventsDirective();
    }
}
// Explicit DI annotation for factory used in angular.directive registration
CustomEventsDirective.factory.$inject = [];
